module.exports = __webpack_public_path__ + "d664201f/img/cadBim.e369a02a.png";